var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondaryHorizontalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 4,
    viewBox: "0 0 18 4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Disable_Horizontal_more",
    transform: "translate(173 -662.2) rotate(90)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(662.2 155)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(662.2 169)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(662.2 162)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondaryHorizontalIcon);
export default __webpack_public_path__ + "static/media/secondary-horizontal-icon.fb60d851909a0f395a6abacbcf741bd0.svg";
export { ForwardRef as ReactComponent };